import React, {Component} from 'react';
import {translate} from 'react-i18next';
import {Table, Modal} from 'react-bootstrap';
import swal from 'sweetalert';
import FlatButton from 'material-ui/FlatButton';
import { notification } from 'react-icons-kit/icomoon/notification';
import SvgIcon from 'react-icons-kit';
import { plasmaticProductRequestDelete, plasmaticProductRequestStatus, unitRequestDelete, unitRequestStatus } from '../../libs/services';


var Config = require('../../config');

class ModalStatus extends Component{
	constructor(props){
		super(props);

		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.onConfirmation = this.onConfirmation.bind(this);

		this.state = {
			show: false,
			option:"",
			observations:"",
			submenu:"",
			status:"",
			user_id:""
		}
	}

	componentDidMount(){
		this.props.onRef(this);
	}

	handleShow(id, status, user){
		var submenu = this.props.search !== "" ? this.props.search : this.props.match.path.replace('/', '');
		
		this.setState({
			show: true,
			unit_request:id,
			submenu:submenu,
			status: status,
			user_id:user
		});
	}

	handleChange(e){
		this.setState({
			[e.target.name]: e.target.value,
		});
	}

	handleClose(){
		this.setState({
			show: false
		});
	}

	async onConfirmation(){
		var url = "";
		var response;
		var submenu = this.props.search !== "" ? this.props.search : this.props.match.path.replace('/', '');

		this.setState({show:false});

		if(submenu === 'distribution' || submenu === 'petition_plasmatic_products'){
			if(this.state.option === 'Cancelar'){
									
				var obj = {};
				if(submenu === 'distribution'){
					obj.id = this.state.unit_request;
					obj.status = 'CANCELADA';
					obj.observations = this.state.observations;
					//url = 'unit_request/status';

					response = await unitRequestStatus(obj, this.props.waiting);

				}else{
					response = await plasmaticProductRequestStatus(this.state.unit_request, 'CANCELADA', this.props.waiting);
					//url = 'plasmatic_product_request/'+this.state.unit_request+'/CANCELADA';
				}
				

				if(response){
					swal('Buen Trabajo', 'Solicitud Cancelada','success');

			    	if(submenu !== 'distribution'){
						this.props.onSearch_send();
						this.props.onSearch_despatch();
					}else{
			    		this.props.onSearch();
			    	}
				}
			}else{
				
				if(submenu === 'distribution'){
					response = await unitRequestDelete(this.state.unit_request, this.props.waiting);
					//url = 'unit_request/'+this.state.unit_request;
				}else{
					response = await plasmaticProductRequestDelete(this.state.unit_request, this.props.waiting);
					//url = 'plasmatic_product_request/'+this.state.unit_request;
				}
				
				if(response){
					swal('Buen Trabajo', 'Solicitud Borrada','success');
		        	if(submenu !== 'distribution'){
			    		this.props.onSearch_send();
			    		this.props.onSearch_despatch();
			    	}else{
			    		var e = {
							target:{
								name:'status',
								value:'all_except'
							}
						};
						this.props.handleChange(e);
						setTimeout(()=>{
							this.props.onSearch();
						}, 500);
			    	}
				}
			}
		}else{
			
			if(submenu === 'distribution'){
				var obj = {};
				obj.id = this.state.unit_request;
				obj.status = 'RECHAZADA';
				obj.observations = this.state.observations;
				//url = 'unit_request/status';

				response = await unitRequestStatus(obj, this.props.waiting);

			}else{
				response = await plasmaticProductRequestStatus(this.state.unit_request, 'RECHAZADA', this.props.waiting);
				//url = 'plasmatic_product_request/'+this.state.unit_request+'/RECHAZADA';
			}
			
			if(response){
				swal('Buen Trabajo', 'Solicitud Rechazada','success');
				if(submenu === 'distribution'){
		    		this.props.onSearch_send();
		    		this.props.onSearch_despatch();
		    	}else{
		    		var e = {
						target:{
							name:'status',
							value:'all_except'
						}
					};
					this.props.handleChange(e);
					setTimeout(()=>{
						this.props.onSearch();
					}, 500);
		    	}
			}
		}

	}

	render(){
		const {t} = this.props;
		var submenu = this.props.search !== "" ? this.props.search : this.props.match.path.replace('/', '');

		return (
			<Modal show={this.state.show} onHide={this.handleClose}>
		       	<Modal.Header closeButton>
		        	<Modal.Title>{this.state.title}</Modal.Title>
		        </Modal.Header>
		        <Modal.Body >
		        	<div className="row">
		        		<div className="col-xs-12">
		        			<div style={{width:"100%", textAlign:"center", color:"orange"}}>
		        				<SvgIcon size={'30%'} icon={notification}  />
		        			</div>
		        		</div>

		        		<div className="col-xs-12" style={{textAlign:"center"}}>
		        			<h3>¿Está seguro?</h3>
		        		</div>
		        		{submenu === 'distribution' || submenu === 'petition_plasmatic_products' ?
			        		<div className="col-xs-12">
			        			<div className="col-xs-12 col-sm-4"><span>Seleccione una opción</span></div>
			        			<div className="col-xs-12 col-sm-4">
			        				<select className="form-control" id="option" name="option" value={this.state.option} onChange={this.handleChange}>
			        					<option value="">Seleccione...</option>
			        					{this.state.status !== 'CANCELADA'?
			        						<option value="Cancelar">Cancelar Pedido</option>
			        					: null}
			        					<option value="Borrar">Borrar Pedido</option>
			        				</select>
			        			</div>
			        		</div>
			        	: <div className="col-xs-12">
			        			<span>Observaciones</span>
			        			<textarea className="form-control" name="observations" id="observations" onChange={this.handleChange} valie={this.observations}>
			        			</textarea>
			        		</div>
			        	}

		        		{this.state.option === 'Cancelar' && submenu !== 'petition_plasmatic_products'?
		        			<div className="col-xs-12">
			        			<span>Observaciones</span>
			        			<textarea className="form-control" name="observations" id="observations" onChange={this.handleChange} valie={this.observations}>
			        			</textarea>
			        		</div>
		        		:null}
			        		
		        	</div>
		        </Modal.Body>
		        <Modal.Footer>
		        	<FlatButton primary={true} label={"Confirmar"} onClick={this.onConfirmation}/>
		        	<FlatButton primary={true} label={t('content.generics.buttons.close')}  onClick={this.handleClose}/>
		        </Modal.Footer>
		    </Modal>

		)
	}

} 

export default translate('translations') (ModalStatus);